import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { LicensesService } from '@connect-services/client/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class LicenseListBloc extends Bloc<LicensesService['licenseControllerGet']> {
    public constructor(service: LicensesService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.licenseControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
